import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddTourDeviationApproval } from "../../../domain/useages/tour-program-approval/add-tour-deviation-approval";
import { RemoteAddTourDeviationApproval } from "../../../data/usecases/tour-program-approval/remote-add-tour-deviation-approval";

export interface AddTourDeviationApprovalInterface {
  AddTourDeviationApprovalState: FetchState;
  addTourDeviationApproval: Function;
}

const initialStates = {
  AddTourDeviationApprovalState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddTourDeviationApprovalSlice: StateCreator<
  AddTourDeviationApprovalInterface
> = (set) => ({
  ...initialStates,
    addTourDeviationApproval: async (payload: AddTourDeviationApproval.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddTourDeviationApproval = new RemoteAddTourDeviationApproval(
      `${BASE_URL}${Endpoints.ADD_TOUR_DEVIATION_APPROVAL}`,

      axiosHttpClient
    );

    set(() => ({ AddTourDeviationApprovalState: FetchState.LOADING }));
    let result = await remoteAddTourDeviationApproval.update(payload);
    return result;
  },
});
